import React from 'react'
import { Link } from 'react-router-dom'

/**
 * Manifest spine: breadcrumb + kicker + title + optional status/actions.
 */
const PageHeader = ({
  kicker = 'Nexus V2',
  title,
  subtitle,
  crumbs = [],
  status,
  actions,
}) => {
  return (
    <header className="mb-6">
      <div className="nx-manifest">
        <span className="nx-manifest-kicker">{kicker}</span>
        {crumbs.length > 0 && (
          <nav aria-label="Breadcrumb" className="flex flex-wrap items-center gap-1.5 text-xs text-muted">
            {crumbs.map((crumb, i) => (
              <React.Fragment key={`${crumb.label}-${i}`}>
                {i > 0 && <span className="text-rule" aria-hidden>/</span>}
                {crumb.to ? (
                  <Link to={crumb.to} className="hover:text-signal transition">
                    {crumb.label}
                  </Link>
                ) : (
                  <span className="text-paper/80">{crumb.label}</span>
                )}
              </React.Fragment>
            ))}
          </nav>
        )}
        {status && <div className="ml-auto sm:ml-0">{status}</div>}
        {actions && (
          <div className={`flex flex-wrap items-center gap-2 ${status ? '' : 'ml-auto'}`}>
            {actions}
          </div>
        )}
      </div>
      <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <h1 className="nx-title">{title}</h1>
          {subtitle && <p className="nx-subtitle mt-1">{subtitle}</p>}
        </div>
      </div>
    </header>
  )
}

export default PageHeader
